import ProfileImage from "../ui/ProfileImage";

interface LinkedInInfoProps {
  pictureUrl: string;
  fullName: string;
  occupation: string;
}

export default function LinkedInInfo({
  pictureUrl,
  fullName,
  occupation,
}: LinkedInInfoProps) {
  return (
    <div className="flex w-full items-center gap-3 rounded-4xl border border-black-200 p-4">
      <ProfileImage src={pictureUrl} alt={`${fullName} profile`} />

      <div className="flex flex-col">
        <span className="text-button-sm">{fullName}</span>

        <span className="text-xs text-black-500">{occupation}</span>
      </div>
    </div>
  );
}
